module.exports = __webpack_public_path__ + "img/bonus_phone_id.c416be45.png";